import UniquePhotoBuilder from "./UniquePhotoBuilder";

export default UniquePhotoBuilder;
